import React from "react";
import { cn } from "../../ui";

/** Ink on a card, not on a tint — so the `-fg` half of each family (TOKEN_CONTRACT §4.0b). */
const TONE_INK = {
  success: "tw-text-success-fg",
  warning: "tw-text-warning-fg",
  danger: "tw-text-danger-fg",
};

/**
 * RecordStat — one labelled figure inside a card: "Present · 41 · of 50 held".
 *
 * Several sit in a grid inside ONE card, which is why this is not `StatsCard`
 * (a card of its own). It renders a `<dt>`/`<dd>` pair, so it must be placed in
 * a `<dl>`; the label is the term, the figure and its hint are the description.
 *
 * Props:
 *   label — what the figure is
 *   value — the figure; a node is fine (a badge, a score pill)
 *   hint  — one short line under it
 *   tone  — "success" | "warning" | "danger" when the figure needs a colour;
 *           omit it otherwise, which is almost always
 */
const RecordStat = ({ label, value, hint, tone }) => (
  <div className="tw-min-w-0">
    <dt className="tw-text-xs tw-font-medium tw-text-content-subtle">{label}</dt>
    <dd className={cn("tw-m-0 tw-mt-0.5 tw-truncate tw-text-lg tw-font-semibold tw-leading-snug", TONE_INK[tone] || "tw-text-content")}>
      {value}
    </dd>
    {hint && <dd className="tw-m-0 tw-text-xs tw-text-content-subtle">{hint}</dd>}
  </div>
);

export default RecordStat;
